module.exports = __webpack_public_path__ + "static/media/close.6f669932.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/forum/close.svg
// module id = ./src/assets/media/forum/close.svg
// module chunks = 16